import { render, staticRenderFns } from "./InstaTagsResults.vue?vue&type=template&id=9ce2ba30&scoped=true"
import script from "./InstaTagsResults.vue?vue&type=script&lang=js"
export * from "./InstaTagsResults.vue?vue&type=script&lang=js"
import style0 from "./InstaTagsResults.vue?vue&type=style&index=0&id=9ce2ba30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce2ba30",
  null
  
)

export default component.exports